import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getObjectiveSlice = createSlice({
    name: "getObjective",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getObjectiveSlice_actions = getObjectiveSlice.actions;
export var fetchData = _getObjectiveSlice_actions.fetchData, fetchDataSuccess = _getObjectiveSlice_actions.fetchDataSuccess, fetchDataFailure = _getObjectiveSlice_actions.fetchDataFailure, resetState = _getObjectiveSlice_actions.resetState;
export default getObjectiveSlice.reducer;
